import { render, staticRenderFns } from "./Crop2Icon.vue?vue&type=template&id=3b000c50&"
import script from "./Crop2Icon.vue?vue&type=script&lang=js&"
export * from "./Crop2Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports